import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1300,
    overflow: 'hidden',
    borderRadius: 20,
  },
  backdrop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    cursor: 'pointer',
  },
  paperContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(2),
    pointerEvents: 'none',
  },
  dialog: {
    width: '100%',
    borderRadius: 12,
    pointerEvents: 'auto',
    overflow: 'hidden',
  },
  content: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
    padding: theme.spacing(2, 2.5, 1.5),
  },
  icon: {
    color: theme.palette.text.secondary,
    marginTop: 2,
    flexShrink: 0,
  },
  title: {
    fontWeight: 600,
    fontSize: '1rem',
    lineHeight: 1.4,
  },
  subtitle: {
    color: theme.palette.text.secondary,
    fontSize: '0.875rem',
    marginTop: theme.spacing(0.5),
  },
  actions: {
    padding: theme.spacing(1, 2.5, 2),
    justifyContent: 'space-between',
  },
}))

export default useStyles
